import React from "react";
import ProfileCom from "../../components/profile/ProfileCom";
import Navbar from "../../components/navbar/Navbar";

const ProfilePage = () => {
  return (
    <>
      <section className="bajaj_main_block">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 p-0">
              <Navbar content="PROFILE" />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 p-0">
              <ProfileCom />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProfilePage;
